module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('app-snackbar', {
    attrs: {
      "text": _vm.snackBarText,
      "show": _vm.snackbar,
      "color": _vm.snackbarColor,
      "timeOut": _vm.timeOut
    },
    on: {
      "update:show": function($event) {
        _vm.snackbar = $event
      }
    }
  }), _vm._v(" "), _c('v-container', {
    staticClass: "pass-change"
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-container', {
    staticClass: "medium-div"
  }, [_c('v-container', {
    staticClass: "without-padding container-img"
  }, [_c('v-img', {
    attrs: {
      "src": require('../../assets/logoPonce.png')
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "text-title"
  }, [_vm._v(_vm._s(_vm.$t('PassChange.setNewPassword')))]), _vm._v(" "), _c('v-form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onPassRecovery.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.validInput),
      callback: function($$v) {
        _vm.validInput = $$v
      },
      expression: "validInput"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-password",
    attrs: {
      "append-icon": _vm.passShow1 ? 'visibility' : 'visibility_off',
      "prepend-inner-icon": "lock",
      "name": "passwordNew",
      "label": _vm.$t('PassChange.newPassword'),
      "id": "passwordNew",
      "type": _vm.passShow1 ? 'text' : 'password',
      "color": "#0098E1",
      "rules": _vm.$ponceConfig.passwordRules,
      "required": ""
    },
    on: {
      "click:append": function($event) {
        _vm.passShow1 = !_vm.passShow1
      }
    },
    model: {
      value: (_vm.passwordNew),
      callback: function($$v) {
        _vm.passwordNew = $$v
      },
      expression: "passwordNew"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    staticClass: "input-password",
    attrs: {
      "append-icon": _vm.passShow2 ? 'visibility' : 'visibility_off',
      "prepend-inner-icon": "lock",
      "name": "passwordConfirm",
      "label": _vm.$t('PassChange.confirmPassword'),
      "id": "passwordConfirm",
      "type": _vm.passShow2 ? 'text' : 'password',
      "color": "#0098E1",
      "rules": _vm.$ponceConfig.passwordRules,
      "required": ""
    },
    on: {
      "click:append": function($event) {
        _vm.passShow2 = !_vm.passShow2
      }
    },
    model: {
      value: (_vm.passwordConfirm),
      callback: function($$v) {
        _vm.passwordConfirm = $$v
      },
      expression: "passwordConfirm"
    }
  })], 1), _vm._v(" "), (_vm.showError) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('p', {
    staticClass: "error-text"
  }, [_vm._v(_vm._s(_vm.$t('PassChange.differentPasswords')))])]) : _vm._e(), _vm._v(" "), _c('v-layout', {
    staticClass: "submit-layout",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    staticClass: "submit-btn",
    attrs: {
      "block": "",
      "color": "info",
      "type": "submit"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('PassChange.setPassword')))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center div-reset-password"
  }, [_c('a', {
    staticClass: "text-reset-password",
    on: {
      "click": _vm.signIn
    }
  }, [_c('u', [_vm._v(_vm._s(_vm.$t('PassChange.signIn')))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-div"
  }, [_c('p', {
    staticClass: "bottom-text"
  }, [_vm._v("PONCE")])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cd71c94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/PassChange.vue
// module id = 1683
// module chunks = 0